const API_URL = import.meta.env.VITE_API_URL;

function parseJwtPayload(token) {
  try {
    const part = token.split('.')[1];
    const padded = part + '='.repeat((4 - (part.length % 4)) % 4);
    return JSON.parse(atob(padded.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

function parseJwtHeader(token) {
  try {
    const part = token.split('.')[0];
    const padded = part + '='.repeat((4 - (part.length % 4)) % 4);
    return JSON.parse(atob(padded.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export function isHrApiSession(token) {
  const payload = parseJwtPayload(token);
  return payload?.token_type === 'HR_API' || payload?.login_type === 'EXCHANGED';
}

export function isSessionExpired(token, skewMs = 60_000) {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return false;
  return payload.exp * 1000 < Date.now() + skewMs;
}

export function needsMsExchange(token) {
  if (!token) return false;
  if (isHrApiSession(token) && !isSessionExpired(token)) return false;
  return parseJwtHeader(token)?.alg === 'RS256';
}

export async function exchangeSessionToken(msToken) {
  const res = await fetch(`${API_URL}/exchangeSessionToken`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${msToken}`,
      'Content-Type': 'application/json',
    },
  });
  return res.json();
}

export async function resolveMsTokenForExchange(instance, account, fallbackToken) {
  if (!account) return fallbackToken || null;
  try {
    const { loginRequest } = await import('../../../authConfig');
    const silent = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return silent?.idToken || fallbackToken || null;
  } catch {
    return fallbackToken || null;
  }
}

export function cookieExpiryDays(days = 30) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d;
}
